import {APIClient} from "../../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Edit profile
export const postJwtProfile = (data: any) =>
    api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data: any) =>
    api.update(url.POST_EDIT_PROFILE + "/" + data.idx, data);

